import { Component, inject, OnInit, signal, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ChangeLanguageComponent } from '@components/change-language/change-language.component';
import { I18nService } from '@common/services/i18n.service';
import { NavbarStateService } from '@common/services/navbar-state.service';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    ChangeLanguageComponent,
  ],
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit {
  private readonly lang = inject(I18nService);
  private readonly navbarStateService = inject(NavbarStateService);

  showLogo: boolean = false;
  data!: any;
  showChnageLanguageDialog = signal(false);
  isArabic = signal<boolean>(false);
  isNavbarDisabled = computed(() => this.navbarStateService.isDisabled());

  // Computed values for template
  navbarOpacity = computed(() => (this.isNavbarDisabled() ? '0.5' : '1'));
  navbarPointerEvents = computed(() =>
    this.isNavbarDisabled() ? 'none' : 'auto'
  );
  logoRoute = computed(() => {
    if (this.isNavbarDisabled()) return null;

    const url = this.router.url;
    return url.includes('login') ||
      url.includes('signup') ||
      url.includes('forgot-password')
      ? '/'
      : '/dashboard';
  });

  constructor(public router: Router) {
    this.handleShowHideOfLogo();
  }

  ngOnInit(): void {
    this.isArabic.set(this.lang.currentLang === 'ar');
  }

  handleShowHideOfLogo() {
    this.router.events.subscribe(res => {
      if (res instanceof NavigationEnd) {
        if (this.router.parseUrl(this.router.url).queryParams['data']) {
          this.data = JSON.parse(
            atob(this.router.parseUrl(this.router.url).queryParams['data'])
          );
        }

        if (this.data?.type === 'dashboard') {
          this.showLogo = false;
        } else {
          this.showLogo = true;
        }
      }
    });
  }

  openChangeLanguage(): void {
    if (this.isNavbarDisabled()) {
      return;
    }

    this.showChnageLanguageDialog.set(true);
  }

  onCloseChangeLanguageDialog(): void {
    this.showChnageLanguageDialog.set(false);
    this.isArabic.set(this.lang.currentLang === 'ar');
  }
}
